module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1048.8c9a7d4c.png";